<template>
  <header-logo-view/>

  <div class="tab-bar-menu">
    <router-link to="/" :class="{active:$route.path == '/'}">
      <home-filled/>
      <span>首页</span>
    </router-link>
    <router-link to="/activities" :class="{active:$route.path.includes('activities')}">
      <icon-font type="icon-dashboard"/>
      <span>活动</span>
    </router-link>
    <router-link to="/brand" :class="{active:$route.path.includes('brand')}">
      <icon-font type="icon-dashboard"/>
      <span>管理</span>
    </router-link>
    <router-link to="/service" :class="{active:$route.path.includes('service')}">
      <gift-filled/>
      <span>服务</span>
    </router-link>
  </div>

  <a-menu mode="horizontal" :selected-keys="[]" class="menu-right">
    <a-menu-item>
      <router-link to="/service/ad">广告</router-link>
    </a-menu-item>
    <a-menu-item>
      <router-link to="/service/wallet">获客费用</router-link>
    </a-menu-item>
    <a-menu-item @click="info.show.contact=true">客服</a-menu-item>
    <a-menu-item @click="showBill">账单</a-menu-item>
    <a-sub-menu>
      <template #title>
        <a-flex style="height: 70px" align="center" gap="middle">
          <a-flex vertical align="flex-end">
            <div class="menu-right-account-item">{{ agent.active.account.phone_number }}</div>
            <div class="menu-right-account-item">{{ agent.active.account.level }}</div>
          </a-flex>
          <a-avatar :size="46"
                    :src="`https://static.pms.guandb.cn/media/image/wechat/${agent.active.account.wx_union_id}.jpg-sq.60`"/>
        </a-flex>
      </template>

      <a-flex vertical :gap="18" class="menu-right-account-sub-title">
        <a-flex justify="space-between" gap="large">
          <a-typography-text copyable strong>{{ agent.active.account.phone_number }}</a-typography-text>
        </a-flex>
        <a-flex align="center">
          <a-tag :color="{'体验版':'default','基础版':'#D99058','专业版':'#eeb400'}[agent.active.account.level.toString()]">
            {{ agent.active.account.level }}
          </a-tag>
          <a-typography-text v-if="agent.active.account.level == '体验版'">永久</a-typography-text>
          <a-typography-text v-else>剩余：
            {{ dayjs(agent.active.account.expiration).diff(dayjs(), 'days') }}天
          </a-typography-text>
        </a-flex>
      </a-flex>

      <a-menu-divider type="divider"/>
      <a-menu-item :icon="h(IconFont,{type:'icon-wepay'})">
        <router-link to="/account/merchant">收款商户</router-link>
      </a-menu-item>
      <a-menu-item>
        <router-link to="/account/wallet">
          <a-flex justify="space-between" align="center" style="height: 100%">
            <icon-font type="icon-wallet-outline" />
            <a-typography-text style="flex: 1">拓客资金包</a-typography-text>
            <a-typography-text strong type="danger">¥{{ agent.active.account.wallet_balance }}</a-typography-text>
          </a-flex>
        </router-link>
      </a-menu-item>
      <a-menu-item :icon="h(IdcardOutlined)">
        <router-link to="/account">账户资料</router-link>
      </a-menu-item>
      <a-menu-divider type="divider"/>
      <a-menu-item key="logout" :icon="h(LogoutOutlined)" @click="logout">退出</a-menu-item>
    </a-sub-menu>
  </a-menu>
  <popup-base v-model:open="info.show.contact">
    <close-outlined style="position: absolute;top: 14px; right: 14px; color: white;" @click="info.show.contact=false"/>
    <img src="@/assets/image/WechatIMG6281.jpg" style="max-width: 400px" alt=""/>
  </popup-base>
  <a-drawer title="账单记录" placement="right" :closable="true" :open="info.show.bill" get-container=".app-main"
            @close="info.show.bill = false">
    <a-table/>
  </a-drawer>
</template>

<script setup lang="ts">

import {
  HomeFilled,
  IdcardOutlined,
  GiftFilled,
  LogoutOutlined,
  CloseOutlined
} from '@ant-design/icons-vue'
import {IconFont} from "@/lib/util";
import HeaderLogoView from "@/views/share/HeaderLogoView.vue";
import {session} from "@/model/session";
import {h, reactive} from "vue"
import PopupBase from "@/views/share/PopupBase.vue";
import {message} from "ant-design-vue";
import router from "@/views";
import dayjs from "dayjs";
import {useRoute} from "vue-router";
import {UserAgent} from "@/model/user_agent";

const info = reactive({show: {contact: false, bill: false}});
const agent = useRoute().meta.agent as UserAgent;

const showBill = () => {
  info.show.bill = true;
}


const logout = () => {
  const done = message.loading('加载中', 0)
  session.logout().then(() => router.push('/login')).finally(done)
}
</script>

<style scoped lang="sass">
@import "@/main.variable"

.tab-bar-menu
  flex: 1 1 auto
  display: flex
  position: relative
  align-items: center
  padding-left: 34px

  > a
    text-decoration: none
    margin-right: 43px
    border: 1px solid rgba(220, 223, 230, .56)
    border-radius: 20px
    height: 36px
    cursor: pointer
    display: flex
    justify-content: center
    align-items: center
    padding: 0 22px 0 16px

    &.active > span
      color: $color-primary

    > span
      padding-left: 6px
      line-height: 22px
      font-weight: 700
      font-size: 16px
      color: #0e1234

.menu-right-account-sub-title
  margin: 28px 18px
  min-width: 240px

.menu-right
  line-height: 70px
  flex: 1 1 auto
  justify-content: right

  .menu-right-account-item
    line-height: 20px
    font-size: 14px
    color: rgba(0, 0, 0, 0.6)


  :deep(.ant-menu-item:not(.ant-menu-item-selected):hover)
    background-color: rgba(0, 0, 0, 0.05)
    color: $color-primary !important


  :deep(.ant-menu-item::after)
    border: none

  :deep(.ant-menu-submenu::after)
    border: none

</style>